import {
  FormControl,
  Grid,
  TextField,
  Typography,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { _COLORS, _STATUTCOLORS } from "../../../utils/_constants";
import { _STYLES } from "../../../utils/_style_constants";
import MouseOverPopover from "../MouseOverPopover";
import HelpIcon from "@mui/icons-material/Help";
import { NumericFormat } from "react-number-format";
import { editInstantRequest } from "../../../utils/formHelper";
import _ from "lodash";
import { createConfirm } from "../../../utils/confirm";

const CreationLettreIntentionAchat = ({
  register,
  currentMandat,
  setCurrentMandat,
  disabledSign = false,
  refresh,
  typeVentes,
  errors,
}) => {
  return (
    <>
      <Grid item xs={12} md={12}>
        <Typography
          variant="h5"
          style={{
            fontWeight: "bold",
            color: _COLORS.primary,
            paddingBottom: 20,
          }}
        >
          {currentMandat.typeVente !== null ? "Modification de la lettre d'intention d'achat" : "Création de la lettre d'intention d'achat"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        Statut : &nbsp;
        <strong>
          <span
            style={{
              color: currentMandat.statut
                ? _STATUTCOLORS[currentMandat?.statut?.nomTechnique]
                : "black",
            }}
          >
            {currentMandat.statut ? currentMandat?.statut?.nom : "N/A"}
          </span>
        </strong>
      </Grid>

      <Grid item xs={12} md={6} display={"flex"} gap={3} alignItems={"center"}>
        <Grid xs={4} item display={"flex"}>
          <Typography variant="body1" sx={{ ..._STYLES.typographyLabelTitle }}>
            Numéro de Mandat*
          </Typography>
          <MouseOverPopover
            title={
              <HelpIcon sx={{ color: _COLORS.black, cursor: "pointer" }} />
            }
            popoverText="Renseigner le numéro de mandat lié à la proposition du proposant."
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <FormControl fullWidth>
            <NumericFormat
              fullWidth
              customInput={TextField}
              size="small"
              id={"numero"}
              label="Numéro de mandat"
              displayType="input"
              disabled={disabledSign}
              value={
                currentMandat?.numero !== null ? currentMandat?.numero : ""
              }
              // Besoin de changer la valeur du state pour que le composant se rafraichisse
              onBlur={(e) => {
                let m = editInstantRequest(
                  e.target.value,
                  currentMandat["@id"],
                  "numero",
                );

                m.then((m) => {
                  if (m["@context"] === "/api/contexts/Error") {
                    refresh();
                  } else {
                    setCurrentMandat(m);
                  }
                });
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={4}>
          <Typography sx={{ ..._STYLES.typographyLabelTitle }}>
            Type de vente*
          </Typography>
        </Grid>
        <Grid item xs={6} md={4}>
          <FormControl sx={{ display: "flex" }} fullWidth>
            <InputLabel id="typeVenteLabel" size="small">
              Type de vente
            </InputLabel>
            <Select
              label="Type de vente"
              size="small"
              disabled={currentMandat.type === "avenant" || disabledSign}
              value={
                currentMandat?.typeVente ? currentMandat.typeVente["@id"] : ""
              }
              {...register("typeVente", { required: false })}
              id="typeVente"
              onChange={(e) => {
                if (!_.isNull(currentMandat?.typeVente)) {
                  createConfirm(
                    "Êtes-vous sûr de vouloir modifier le type de vente ? (Les ventilations de prix déjà existantes seronts supprimées)",
                  )
                    .fire({})
                    .then((result) => {
                      if (result.isConfirmed) {
                        // Traitement
                        let m = editInstantRequest(
                          e.target.value,
                          currentMandat["@id"],
                          "typeVente",
                        );

                        m.then((m) => {
                          setCurrentMandat(m);
                        });
                      } else {
                        // Annulation
                        setCurrentMandat(currentMandat);
                      }
                    });
                } else {
                  let m = editInstantRequest(
                    e.target.value,
                    currentMandat["@id"],
                    "typeVente",
                  );

                  m.then((m) => {
                    setCurrentMandat(m);
                  });
                }
              }}
            >
              {typeVentes.map((typeVente, i) => (
                <MenuItem key={i} value={typeVente["@id"]}>
                  {typeVente.nom}
                </MenuItem>
              ))}
            </Select>
            {errors.typeVente?.type === "required" && (
              <Typography sx={_STYLES.errorMessage}>
                Veuillez selectionner un type de vente
              </Typography>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default CreationLettreIntentionAchat;
